import { AxiosError } from 'axios'
import React, { useEffect, useState } from 'react'
import { useQuery as useQueryRQ } from 'react-query'
import Store from 'store'
import HomePage from '../../HomePage'
import Loading from '../../Loading'
import Login from '../../Login'
import { fetchLeads } from '../../utils/lead'
import { checkTokenValidity } from '../../utils/validate-token'

const Leads: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)
  const [tokenChecked, setTokenChecked] = useState<boolean>(false)
  const [isAuthorized, setIsAuthorized] = useState<string>('')
  const accessToken = Store.get('aff-tok')

  const [lazyParams, setLazyParams] = useState<any>({
    first: 0,
    rows: 100,
    page: 0,
  })

  const {
    data: dataSource,
    isFetching: leadsFetching,
    isLoading: leadsLoading,
    refetch: refetchLeads,
  } = useQueryRQ(
    ['affiliate-leads', accessToken],
    () => fetchLeads(Store.get('filters') || lazyParams, accessToken),
    {
      refetchOnWindowFocus: false,
      notifyOnStatusChange: true,
      enabled: isLoggedIn && !!isAuthorized,
      retry: 1,
      onError: (error: AxiosError) => {
        if (error?.response?.data?.statusCode === 401) {
          setIsLoggedIn(false)
        }
      },
    },
  )

  useEffect(() => {
    // check for credentials in localStorage
    const affId = Store.get('aff-id')
    const affTok = Store.get('aff-tok')

    if (affId && affTok) {
      refetchLeads()

      checkTokenValidity(affTok).then((result) => {
        if (result.id) {
          setIsAuthorized(affTok)
          setIsLoggedIn(true)
        } else {
          setIsLoggedIn(false)
        }
        setTokenChecked(true) // Mark token check as completed
      })
    } else {
      setTokenChecked(true) // Mark token check as completed if credentials are not present
    }

    setLoading(false)
  }, [refetchLeads])

  if (loading) return <Loading />

  if (!tokenChecked) return null

  return (
    <>
      {isLoggedIn && dataSource !== null ? (
        <HomePage
          setIsLogin={setIsLoggedIn}
          dataSource={dataSource}
          leadsFetching={leadsFetching}
          leadsLoading={leadsLoading}
          refetchLeads={refetchLeads}
          lazyParams={lazyParams}
          setLazyParams={setLazyParams}
          isLoggedIn={isLoggedIn}
          isAuthorized={isAuthorized}
        />
      ) : (
        <Login />
      )}
    </>
  )
}

export default Leads
